/** Tipos de dominio — Yexzabel by Grace */

/** Datos configurables del negocio (src/config/config.json). */
export interface Config {
  /** Nombre del negocio, usado en mensajes de WhatsApp. */
  brand: string;
  /** Número WhatsApp en formato internacional sin "+" ni espacios (ej: 56989274098). */
  phoneWA: string;
  /** Número en formato legible para mostrar en la UI. */
  phoneDisplay: string;
  city: string;
  email: string;
  hours: string;
  /** Franjas horarias disponibles para reservar (HH:MM). */
  slots: string[];
  /** Días de la semana cerrados (0 = domingo). */
  closedWeekdays: number[];
  /** IDs de servicios destacados en el home. */
  featuredServices: string[];
  /** Categorías mostradas en las pestañas del menú. */
  categories: string[];
}

/** Catálogo de servicios (src/config/services.json). */
export interface Service {
  id: string;
  cat: string;
  name: string;
  /** Precio en CLP. */
  price: number;
  /** Duración en minutos. */
  dur: number;
  /** Texto auxiliar junto al precio (ej: "desde"). */
  note?: string;
}

export type ReservaStatus = "confirmada" | "cancelada";

/** Reserva guardada localmente. */
export interface Reserva {
  id: string;
  service: string;
  serviceId: string;
  price: number;
  /** Fecha ISO (YYYY-MM-DD). */
  date: string;
  /** Hora (HH:MM). */
  time: string;
  name: string;
  phone: string;
  note: string;
  status: ReservaStatus;
  createdAt: number;
}

/** Cliente del historial de servicios. */
export interface Contacto {
  id: string;
  name: string;
  phone: string;
  notes: string;
  /** Entradas "YYYY-MM-DD HH:MM · Servicio". */
  history: string[];
}

/** Estado en memoria del asistente de reserva (paso a paso). */
export interface BookingState {
  service: string | null;
  date: string | null;
  time: string | null;
  name: string;
  phone: string;
  note: string;
}

/** Vistas (secciones) de la SPA. */
export type ViewId = "inicio" | "servicios" | "reservar" | "agenda" | "contactos" | "contacto";

export const VIEW_IDS: readonly ViewId[] = [
  "inicio",
  "servicios",
  "reservar",
  "agenda",
  "contactos",
  "contacto",
];

/** Día del calendario disponible en el asistente. */
export interface CalendarDay {
  /** Fecha ISO (YYYY-MM-DD). */
  iso: string;
  /** Día de la semana corto (Dom, Lun, ...). */
  dow: string;
  /** Número de día del mes. */
  day: number;
  /** Mes corto (ene, feb, ...). */
  month: string;
  /** true si el negocio está cerrado ese día. */
  closed: boolean;
}
